/* eslint-disable max-len */
import { ReactComponent as VK } from "../../../../assets/icons/vk.svg"
import { ReactComponent as Instagram } from "../../../../assets/icons/instagram.svg"
import { ReactComponent as TikTok } from "../../../../assets/icons/tiktok.svg"
import { ReactComponent as Youtube } from "../../../../assets/icons/youtube.svg"
import { ReactComponent as Telegram } from "../../../../assets/icons/telegram.svg"
import { ReactComponent as Rutube } from "../../../../assets/icons/rutube.svg"
import { ReactComponent as Max } from "../../../../assets/icons/max.svg"
import { ReactComponent as SoundCloud } from "../../../../assets/icons/soundcloud.svg"
import { ReactComponent as Spotify } from "../../../../assets/icons/spotify.svg"
import { ReactComponent as YM } from "../../../../assets/icons/yandex-music.svg"
import { ArtistFormStatus } from "../../../../models/ArtistModels/artistForm.model"

export interface SocialNetworksField {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  name: 'vkontakteUrl' | 'instagramUrl' | 'tiktokUrl' | 'youtubeUrl' | 'telegramUrl' | 'rutubeUrl' | 'maxUrl';
  placeholder: string;
}

export const projectInSocial: SocialNetworksField[] = [
  {
    name: 'vkontakteUrl',
    icon: VK,
    placeholder: 'Vkontakte'
  },
  {
    name: 'instagramUrl',
    icon: Instagram,
    placeholder: 'Instagram'
  },
  {
    name: 'tiktokUrl',
    icon: TikTok,
    placeholder: 'Tiktok'
  },
  {
    name: 'youtubeUrl',
    icon: Youtube,
    placeholder: 'Youtube'
  },
  {
    name: 'telegramUrl',
    icon: Telegram,
    placeholder: 'Telegram'
  },
  {
    name: 'rutubeUrl',
    icon: Rutube,
    placeholder: 'Rutube'
  },
  {
    name: 'maxUrl',
    icon: Max,
    placeholder: 'MAX'
  }
]

// interface MusicProjectLinksField {
//   icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
//   name: 'musicVkontakteUrl' | 'musicSoundcloudUrl' | 'musicSpotifyUrl' | 'musicYandexUrl';
//   placeholder: string;
// }

// export const musicProjectLinks: MusicProjectLinksField[] = [
//   {
//     name: 'musicVkontakteUrl',
//     icon: VK,
//     placeholder: 'VK'
//   },
//   {
//     name: 'musicSoundcloudUrl',
//     icon: SoundCloud,
//     placeholder: 'Soundcloud'
//   },
//   {
//     name: 'musicSpotifyUrl',
//     icon: Spotify,
//     placeholder: 'Spotify'
//   },
//   {
//     name: 'musicYandexUrl',
//     icon: YM,
//     placeholder: 'Yandex.music'
//   }
// ]

interface MemberSocialField {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  name: 'vkontakteUrl' | 'instagramUrl' | 'tiktokUrl' | 'youtubeUrl' | 'telegramUrl' | 'rutubeUrl' | 'maxUrl';
  placeholder: string;
}

export const memberSocial: MemberSocialField[] = [
  {
    name: 'vkontakteUrl',
    icon: VK,
    placeholder: 'Vkontakte'
  },
  {
    name: 'instagramUrl',
    icon: Instagram,
    placeholder: 'Instagram'
  },
  {
    name: 'tiktokUrl',
    icon: TikTok,
    placeholder: 'Tiktok'
  },
  {
    name: 'youtubeUrl',
    icon: Youtube,
    placeholder: 'Youtube'
  },
  {
    name: 'telegramUrl',
    icon: Telegram,
    placeholder: 'Telegram'
  },
  {
    name: 'rutubeUrl',
    icon: Rutube,
    placeholder: 'Rutube'
  },
  {
    name: 'maxUrl',
    icon: Max,
    placeholder: 'MAX'
  }
]

export const formStatusLabels: {
  formStatus: ArtistFormStatus;
  label: string;
}[] = [
  {
    formStatus: ArtistFormStatus.EDITING,
    label: 'Редактируется артистом'
  },
  {
    formStatus: ArtistFormStatus.MODERATION,
    label: 'На модерации'
  },
  {
    formStatus: ArtistFormStatus.APPROVED,
    label: 'Заявка утверждена'
  },
  {
    formStatus: ArtistFormStatus.CHECKED,
    label: 'На рассмотрении экспертов'
  }
]
